import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { tradingCompetitionKeys } from '../tradingCompetition.keys';
import { getAllTradingCompetitions } from '../tradingCompetition.service';
/**
 * Queries all trading competitions with stats
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param enabled Whether the query should be enabled
 * @example const { data, isLoading } = useAllTradingCompetitions('my-community');
 */
export const useAllTradingCompetitions = (subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tradingCompetitionKeys.allTradingCompetitions(domain),
        queryFn: async () => getAllTradingCompetitions(domain),
        retry: 1,
    });
};
